export const config = {
  apiUrl: window.location.origin + "/api",
  authUrl: window.location.origin + "/api/auth",
};

export const isDevMode = import.meta.hot !== undefined;
